import { Box, Typography } from '@mui/material';

import type { ReactNode } from 'react';

interface TermProps {
  children: ReactNode;
  icon: ReactNode;
}

const Term: React.FC<TermProps> = ({ children, icon }: TermProps) => (
  <Box component='dt' sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color: 'typography.light', m: 0 }}>
    <Box sx={{ display: 'none', '@media (min-width: 410px)': { display: 'flex' } }}>{icon}</Box>
    <Typography variant='p3' sx={{ opacity: 0.65 }}>
      {children}
    </Typography>
  </Box>
);

export default Term;
